<img src="{{srcImage}}" (error)="handleError()" [class.season]="isSeason"/>
